import { baseURL, webRoot } from "../utils/urlHelpers";
export const THUMBNAIL_NOT_AVAILABLE_URL = `../../../../../Content/images/thumbnail_not_available.png`;

/**
 * Gets the appropriate thumbnail URL for the Item. There are 3 potential URLs to be generated
 * 1. Whenever the thumbnail ID was provided and the thumbnail has been generated
 * 2. Whenever the thumbnail ID doesn't exist and we need to tell the server to generate a thumbnail
 * 3. Whenever there is no thumbnail available at all and we need to use the generic "Thumbnail Not Available" image
 *
 * @export
 * @param {string} thumbnailId The thumbnailId GUID
 * @param {number} width The requested width of the thumbnail
 * @param {number} height The request height of the thumbnail
 * @param {number} documentId The parent Document ID of the Item
 * @returns The correct URL to request for the item's thumbnail
 */
export function generateThumbnailUrl(thumbnailId, width, height, documentId) {
	if (hasExistingThumbnail(thumbnailId)) {
		return `${baseURL()}/Files/Display/${thumbnailId}?w=${width}&h=${height}`;
	}

	if (shouldGenerateThumbnail(documentId)) {
		return `${baseURL()}/Files/ThumbnailForDocument/${documentId}?w=${width}&h=${height}`;
	}

	return THUMBNAIL_NOT_AVAILABLE_URL;
}

/**
 * Determines if the item has an existing thumbnail. 
 * If a thumbnail already exists for the item then thumbnailId will be a GUID string. 
 * If the thumbnail doesn't exist the server will return "none"
 * 
 * @param {string} thumbnailId The thumbnail file Id 
 * @returns True if the thumbnail file already exists, false otherwise
 */
function hasExistingThumbnail(thumbnailId) {
	return thumbnailId && thumbnailId != "none";
}

/**
 * Determines if we should call the endpoint which generates a thumbnail for the item.
 * If a documentId is present then we know the item has finished processing and has been 
 * associated to its parent Folder
 *
 * @param {*} documentId
 * @returns
 */
function shouldGenerateThumbnail(documentId) {
	return !!documentId;
}